module.exports = "<h2>\n  <span class=\"point no-margin\" [ngStyle]=\"{background: color}\"></span>\n\n  Features\n</h2>\n\n<ul class=\"feature oneline\">\n  <li *ngFor=\"let feature of sortedFeatures\" style=\"height: 90px;\">\n    <park-feature-control [feature]=\"feature[1]\" [featureId]=\"feature[0]\" [parkId]=\"parkId\" [id]=\"id\"></park-feature-control>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/controls/features/features/park-feature-controls.html
// module id = ./src/app/dashboard/parks/park/controls/features/features/park-feature-controls.html
// module chunks = main